<!-- 3*2 商品分类 -->
<template>
  <div class="goods-category-container" :style="{marginBottom: (data.marginBottom ) / 16 + 'rem'}">
    <h2>{{ data.title }}</h2>
    <ul class="list">
      <li v-for="(item, index) in data.lists" :key="index" class="list-item" @click="click(item)">
        <div>
          <img :src="item.iconUrl" alt="" loading="lazy">
          <div class="middle">
            <p class="item-title">{{ item.title }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import clientUtil from '../common/clientUtil';
export default {
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {}
  },
  methods: {
    click(item) {
      // TODO 链接跳转
      console.log(item.link);
    }
  }
}
</script>

<style lang="less" scoped>
  .goods-category-container {
    margin: 0 auto 12px;
    width: 271px;
    padding-bottom: 4px;
    background: #fff;
    border-radius: 8px;

    h2 {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      font-size: 15px;
      line-height: 22px;
      color: #2E2E33;
      padding: 13px 0 13px 13px;
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      padding: 0 11px;
      justify-content: flex-start;

      &-item {
        width: 72px;
        height: 111px;
        background: #fff;
        border-radius: 4px;
        text-align: center;
        margin-right: 16px;
        &:nth-child(3n) {
          margin-right: 0;
        }

        img {
          margin: 8px auto 7px;
          width: 42px;
          height: 57px;
          display: block;
        }

        .item-title {
          margin-bottom: 16px;
          margin-top: 4px;
          font-size: 13px;
          font-family: DINPro-Regular, DINPro;
          font-weight: 400;
          color: #2e2e33;
          line-height: 19px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>
